@if(loading) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="'Buscando'"></app-loader>
  </div>
}

<div class="p-6 space-y-5">

  <!-- Filters -->
  <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 space-y-4">
    <h2 class="text-sm font-semibold text-mustard-700 dark:text-mustard-400 uppercase tracking-wide">Filtros</h2>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Año</label>
        <p-select [options]="years" [(ngModel)]="selectedYear" optionLabel="text" optionValue="value"
          (onChange)="changeYear($event)" class="w-full" />
      </div>
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Periodo</label>
        <p-select [options]="seasons" [(ngModel)]="selectedSeason" optionLabel="text" optionValue="value"
          (onChange)="changeSeason($event)" class="w-full" />
      </div>
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Tipo de reporte</label>
        <p-select [options]="reportTypes" [(ngModel)]="selectedReport" optionLabel="text" optionValue="value"
          (onChange)="changeReportType($event)" class="w-full" />
      </div>
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Tarjeta desde</label>
        <p-select [options]="fromDevices" [(ngModel)]="fromCard" optionLabel="text" optionValue="value"
          (onChange)="changeDeviceFilter($event, true)" [filter]="fromDevices.length > 10" filterPlaceholder="Buscar..."
          class="w-full" />
      </div>
    </div>

    @if(fromCard !== -1) {
      <div class="w-full sm:w-1/2 lg:w-1/4">
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Tarjeta hasta</label>
        <p-select [options]="toDevices" [(ngModel)]="toCard" optionLabel="text" optionValue="value"
          (onChange)="changeDeviceFilter($event, false)" [filter]="toDevices.length > 10" filterPlaceholder="Buscar..."
          class="w-full" />
      </div>
    }

    <div class="flex justify-end">
      <button pButton label="Consultar" icon="pi pi-search" class="p-button-sm" (click)="getCharts()"></button>
    </div>
  </div>

  <!-- Charts -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-5">
    <div class="md:col-span-2 bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5">
      <h3 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100 mb-3">Comparativo de consumos</h3>
      <app-bar-chart [datasets]="dataSets" [method]="''" [labels]="labelsChart"
        [clientNumber]="data.Client_number" [options]="chartOptions" [isDownloadable]="true"></app-bar-chart>
    </div>
    <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5">
      <h3 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100 mb-3">Distribución por producto</h3>
      <app-pie-chart [datasets]="dataSetPie" [method]="''" [labels]="labelsPie"
        [clientNumber]="data.Client_number" [options]="chartOptions" [isDownloadable]="true"></app-pie-chart>
    </div>
  </div>
</div>
